import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, renderSlot as _renderSlot, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import NavFooter from '@/components/NavFooter.vue';
    import NavMain from '@/components/NavMain.vue';
    import NavUser from '@/components/NavUser.vue';
    import {
        Sidebar,
        SidebarContent,
        SidebarFooter,
        SidebarHeader,
        SidebarMenu,
        SidebarMenuButton,
        SidebarMenuItem,
        SidebarSeparator,
    } from '@/components/ui/sidebar';
    import { type NavItem, type SharedData } from '@/types';
    import { Link, usePage } from '@inertiajs/vue3';
    import AppLogo from './AppLogo.vue';
    import { computed, type ComputedRef } from 'vue';
    import { mainNavItems, secondaryNavItems, footerNavItems } from '@/utils/pages';
    import { useNavPermissions } from '@/composables/useNavPermissions';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'AppSidebar',
  setup(__props) {

    const { filterNavItems } = useNavPermissions();

    const navigation = computed(() => filterNavItems(mainNavItems));
    const secondaryNavigation = computed(() => filterNavItems(secondaryNavItems));
    const footerNavigation = computed(() => filterNavItems(footerNavItems));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Sidebar), { collapsible: "icon" }, {
      default: _withCtx(() => [
        _createVNode(_unref(SidebarHeader), null, {
          default: _withCtx(() => [
            _createVNode(_unref(SidebarMenu), null, {
              default: _withCtx(() => [
                _createVNode(_unref(SidebarMenuItem), null, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SidebarMenuButton), {
                      class: "h-20 pt-[24px] pl-[28px]",
                      "as-child": ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(Link), {
                          href: _ctx.route('v2.index')
                        }, {
                          default: _withCtx(() => [
                            _createVNode(AppLogo)
                          ]),
                          _: 1
                        }, 8, ["href"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(SidebarContent), null, {
          default: _withCtx(() => [
            _createVNode(NavMain, { items: navigation.value }, null, 8, ["items"]),
            _createVNode(_unref(SidebarSeparator)),
            _createVNode(NavMain, { items: secondaryNavigation.value }, null, 8, ["items"])
          ]),
          _: 1
        }),
        _createVNode(_unref(SidebarFooter), null, {
          default: _withCtx(() => [
            _createVNode(NavFooter, { items: footerNavigation.value }, null, 8, ["items"]),
            _createVNode(NavUser)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default")
  ], 64))
}
}

})